var exports = {
  "S": "x9245d464--069e56--odd",
  "B": "x9245d464--069e56--even",
};

module.exports = exports;
